
import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { NotificationsService } from 'src/app/services/notifications.service';
import { PlatformService } from 'src/app/services/platform.service';

@Component({
    selector: 'app-hero-section',
    templateUrl: './hero-section.component.html',
    styleUrls: ['./hero-section.component.scss'],
    imports: []
})
export class HeroSectionComponent {
  constructor(
    private platformService: PlatformService,
    private router: Router,
    private notif: NotificationsService,
  ) {}

  tryBuildevo() {
    if (this.platformService.isIOS() || this.platformService.isAndroid()) {
      //  in the future, when the client wants so, update this to open the app store.
      this.notif.showInfo('Reach us at contact@buildevo.com for a demo.');
      return;
    }
    this.router.navigate(['/auth/register']);
  }

  private openIOSAppstore() {
    const appStoreUrl = 'https://apps.apple.com/ro/app/skillhop/id1576722080';
    window.location.href = appStoreUrl;
  }
}
